<template>
  <i-mdi-cancel />
</template>
